<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Table of contents</title>
<link href="template.css" rel="stylesheet" type="text/css"/>
<div id="table-of-contents">
<p class="chap-ttl"><a id="pvii">Contents</a></p><a id="pvii">
</a><p class="bkfm-toc-ttl"><a id="pvii"></a><a href="#/Acknowledgements"><span class="epub-italic-normal-normal">Acknowledgements</span></a></p>
<p class="bkfm-toc-ttl"><a href="#/Abbreviations"><span class="epub-italic-normal-normal">List of abbreviations</span></a></p>
<p class="bkfm-toc-ttl">  <a href="#/Chapter01">1 Introduction</a></p>
<p class="bkfm-toc-ttl">  <a href="#/Chapter02">2 Strategies for reading 1: Before the Renaissance</a></p>
<p class="bkfm-toc-ttl">  <span href="#/Chapter03" title="Link target outside of Sample">3 Strategies for reading 2: From the Renaissance until the present</span></p>
<p class="bkfm-toc-ttl">  <span href="#/Chapter04" title="Link target outside of Sample">4 The world of Genesis: Locating the text in its time and place</span></p>
<p class="bkfm-toc-ttl">  <span href="#/Chapter05" title="Link target outside of Sample">5 Creation: Genesis 1.1—2.25</span></p>
<p class="bkfm-toc-ttl">  <span href="#/Chapter06" title="Link target outside of Sample">6 The entrance of evil: Genesis 3.1–24</span></p>
<p class="bkfm-toc-ttl">  <span href="#/Chapter07" title="Link target outside of Sample">7 From Cain to the great flood: Genesis 4.1—6.8</span></p>
<p class="bkfm-toc-ttl">  <span href="#/Chapter08" title="Link target outside of Sample">8 From Noah to the tower of Babel: Genesis 6.9—11.26</span></p>
<p class="bkfm-toc-ttl">  <span href="#/Chapter09" title="Link target outside of Sample">9 Abraham, Sarah and Isaac: Genesis 11.27—25.18</span></p>
<p class="bkfm-toc-ttl"><span href="#/Chapter10" title="Link target outside of Sample">10 The Jacob story: Genesis 25.19—37.1</span></p>
<p class="bkfm-toc-ttl"><span href="#/Chapter11" title="Link target outside of Sample">11 The Joseph story: Genesis 37.2—50.26</span></p>
<p class="bkfm-toc-ttl"><span href="#/Bibliography" title="Link target outside of Sample"><span class="epub-italic-normal-normal">Bibliography</span></span></p>
<p class="bkfm-toc-ttl"><span href="#/Index1" title="Link target outside of Sample"><span class="epub-italic-normal-normal">Search items for biblical references</span></span></p>
<p class="bkfm-toc-ttl"><span href="#/Index2" title="Link target outside of Sample"><span class="epub-italic-normal-normal">Search items for pre-modern sources</span></span></p>
<p class="bkfm-toc-ttl"><span href="#/Index3" title="Link target outside of Sample"><span class="epub-italic-normal-normal">Search names for authors</span></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Table_of_contents.vue?4a737347